const rightDescription = {
  cc0: {
    ja: '自由に利用可',
    urlJa: 'https://creativecommons.org/publicdomain/zero/1.0/deed.ja',
    en: 'Public Domain Dedication ',
    urlEn: 'https://creativecommons.org/publicdomain/zero/1.0/',
  },
  pdm: {
    ja: '自由に利用可',
    urlJa: 'https://creativecommons.org/publicdomain/mark/1.0/deed.ja ',
    en: 'Public Domain Mark',
    urlEn: 'https://creativecommons.org/publicdomain/mark/1.0/',
  },
  ccby: {
    ja: 'クレジット表記をすれば利用可',
    urlJa: 'https://creativecommons.org/licenses/by/4.0/deed.ja',
    en: 'Attribution',
    urlEn: 'https://creativecommons.org/licenses/by/4.0/',
  },
  ccbysa: {
    ja: 'クレジット表記をすれば利用可、改変と再配布に条件あり',
    urlJa: 'https://creativecommons.org/licenses/by-sa/4.0/deed.ja',
    en: 'Attribution ShareAlike',
    urlEn: 'https://creativecommons.org/licenses/by-sa/4.0/',
  },
  ccbynd: {
    ja: 'クレジット表記をすれば利用可、改変は禁止',
    urlJa: 'https://creativecommons.org/licenses/by-nd/4.0/deed.ja',
    en: 'Attribution-NoDerivs',
    urlEn: 'https://creativecommons.org/licenses/by-nd/4.0/',
  },
  ccbync: {
    ja: '非営利目的ならクレジット表記をすれば利用可',
    urlJa: 'https://creativecommons.org/licenses/by-nc/4.0/deed.ja',
    en: 'Attribution-NonCommercial',
    urlEn: 'https://creativecommons.org/licenses/by-nc/4.0/',
  },
  ccbyncsa: {
    ja: '非営利目的ならクレジット表記をすれば利用可、改変と再配布に条件あり',
    urlJa: 'https://creativecommons.org/licenses/by-nc-sa/4.0/deed.ja',
    en: 'Attribution-NonCommercial-ShareAlike',
    urlEn: 'https://creativecommons.org/licenses/by-nc-sa/4.0/',
  },
  ccbyncnd: {
    ja: '非営利目的ならクレジット表記をすれば利用可、改変禁止',
    urlJa: 'https://creativecommons.org/licenses/by-nc-nd/4.0/deed.ja',
    en: 'Attribution-NonCommercial-NoDerivs',
    urlEn: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
  },
  incr: {
    ja: '原則として許諾を得る手続が必要',
    urlJa: '',
    en: 'Need Copyright Permission',
    urlEn: 'https://rightsstatements.org/page/InC/1.0/?language=en',
  },
  incr_edu: {
    ja: '許諾を得ずに教育目的では利用可',
    urlJa: '',
    en: 'No Permision for Educational Uses',
    urlEn: 'https://rightsstatements.org/page/InC-EDU/1.0/?language=en',
  },
  nocr_cont: {
    ja: 'パブリックドメインであるが申請などの手続が必要',
    urlJa: '',
    en: 'Need Inquiry',
    urlEn: 'https://rightsstatements.org/page/NoC-CR/1.0/?language=en',
  },
  nocr_other: {
    ja: 'パブリックドメインであるが他の法的制限があり配慮が必要',
    urlJa: '',
    en: 'Need Attention',
    urlEn: 'https://rightsstatements.org/page/NoC-OKLR/1.0/?language=en',
  },
  uneval: {
    ja: '著作権の状態が不明で調査が必要',
    urlJa: '',
    en: 'Need Copyright Survey',
    urlEn: 'https://rightsstatements.org/page/CNE/1.0/?language=en',
  },
  undet: {
    ja: '裁定制度を利用すれば利用可',
    urlJa:
      'https://www.bunka.go.jp/seisaku/chosakuken/seidokaisetsu/chosakukensha_fumei/',
    en: 'Orphan Work in Japan',
    urlEn:
      'https://www.bunka.go.jp/seisaku/chosakuken/seidokaisetsu/chosakukensha_fumei/',
  },
  others: { ja: '該当なし', urlJa: '', en: 'Not Applicable', urlEn: '' },
  various: {
    ja: '資料によって異なります。個別の資料のページを確認してください。',
    urlJa: '',
    en: 'It depends on the cotent. Please check the individual material pages.',
    urlEn: '',
  },
}

type PurposeType = 'ok' | 'conditional' | 'ng' | 'na'

interface RightSummary {
  educational: PurposeType
  nonCommerce: PurposeType
  commerce: PurposeType
}

export const useRightsData = () => {

  const getRightsSummary = (rightsType: string) => {
    const ret: RightSummary = {
      educational: 'ok',
      nonCommerce: 'ok',
      commerce: 'ok',
    }
    if (['ccbynd', 'ccbyncnd', 'nocr_cont', 'nocr_other'].includes(rightsType)) {
      ret.educational = 'conditional'
    }
    if (
      ['ccbynd', 'ccbyncnd', 'nocr_cont', 'nocr_other', 'incr_edu'].includes(
        rightsType
      )
    ) {
      ret.nonCommerce = 'conditional'
    }
    if (['ccbynd', 'nocr_cont', 'nocr_other'].includes(rightsType)) {
      ret.commerce = 'conditional'
    }
    if (['incr', 'uneval', 'undet'].includes(rightsType)) {
      ret.educational = 'ng'
      ret.nonCommerce = 'ng'
    }
    if (
      [
        'ccbync',
        'ccbyncsa',
        'ccbyncnd',
        'incr',
        'incr_edu',
        'uneval',
        'undet',
      ].includes(rightsType)
    ) {
      ret.commerce = 'ng'
    }

    if (rightsType === 'others') {
      ret.commerce = 'na'
      ret.nonCommerce = 'na'
      ret.educational = 'na'
    }

    return ret
  }

  const getRightDescription = (rights: string) => {
    return rightDescription[rights]
  }

  return {
    getRightsSummary,
    getRightDescription,
  }
}
